"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHoverCapture = useHoverCapture;
const react_1 = require("react");
/*
  Hook to handle hover capture:
  an event when the pointer is
  positioned above an element
  during the given duration.
 */
function useHoverCapture({ onHoverCaptured, isHoverAvailable, captureDuration, }) {
    const durationTimeout = (0, react_1.useRef)(null);
    const [hoverCaptured, setHoverCaptured] = (0, react_1.useState)(false);
    const clearDurationTimeout = (0, react_1.useCallback)(() => {
        if (durationTimeout.current) {
            clearTimeout(durationTimeout.current);
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (hoverCaptured) {
            setHoverCaptured(false); // reset hoverCaptured
            clearDurationTimeout(); // clear timeout
            if (isHoverAvailable) {
                onHoverCaptured();
            }
        }
    }, [hoverCaptured, clearDurationTimeout, isHoverAvailable, onHoverCaptured]);
    const handleMouseEnter = (0, react_1.useCallback)(() => {
        if (isHoverAvailable) {
            durationTimeout.current = setTimeout(() => setHoverCaptured(true), captureDuration);
        }
    }, [isHoverAvailable, captureDuration]);
    const handleMouseLeave = (0, react_1.useCallback)(() => {
        /*
        Clear timeout on mouse leave
         */
        clearDurationTimeout();
    }, [clearDurationTimeout]);
    (0, react_1.useEffect)(() => {
        /*
        Clear timeout, if isHoverAvailable = false
         */
        if (!isHoverAvailable) {
            clearDurationTimeout();
        }
    }, [isHoverAvailable, clearDurationTimeout]);
    (0, react_1.useEffect)(() => {
        /*
        Clear timeout on unmount
         */
        return () => {
            clearDurationTimeout();
        };
    }, [clearDurationTimeout]);
    return {
        handleMouseEnter,
        handleMouseLeave,
    };
}
//# sourceMappingURL=useHoverCapture.js.map